import { useEffect } from 'react';
import { PaymentRequest, WebPayHookOptions } from '../types';
import { useWebPayModal } from '../hooks';


interface WebPayModalProps {
  isOpen: boolean;
  onClose: () => void;
  paymentRequest: PaymentRequest;
  options?: WebPayHookOptions;
}

export const WebPayModal: React.FC<WebPayModalProps> = ({
  isOpen,
  onClose,
  // config,
  paymentRequest,
  options,
}) => {
  const modalState = useWebPayModal({
    isOpen,
    onClose,
    // config,
    paymentRequest,
    options,
  });

useEffect(() => {
  if (!isOpen) return;

  // 1. First try immediate modification
  modifyOverlay();

  // 2. Set up mutation observer for dynamic iframe content
  const observer = new MutationObserver(() => {
    modifyOverlay();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return () => observer.disconnect();
}, [isOpen]);

const modifyOverlay = () => {
  const selectors = [
    '.overlay-class', 
    '.modal-overlay',
    '[class*="overlay"]',
    'div[style*="background-color: rgba(0, 0, 0"]'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll<HTMLElement>(selector);
    elements.forEach(el => {
      el.style.cssText = `
        background-color: transparent !important;
        pointer-events: none !important;
        z-index: -1 !important;
      `;
    });
  });
};

  return null;
};